import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

/** A signup device aggregated by visitorId (the "find the abuser" view). */
export type DeviceFingerprintRow = {
  visitorId: string;
  signupCount: number;
  clinicCount: number;
  lastSeen: string | null;
  confidence: number | null;
  bot: string | null;
  vpn: boolean | null;
  incognito: boolean | null;
  velocity24h: number | null;
  emails: string | null;
  clinicIds: string | null;
  isBlocked: boolean;
};

export type BlocklistRow = {
  visitorId: string;
  reason: string | null;
  blockedBy: string | null;
  notes: string | null;
  createdAt: string;
};

export type DeviceLookupParams = {
  email?: string;
  clinicId?: string;
  visitorId?: string;
};

export type BlockDeviceBody = {
  visitorId: string;
  reason?: string;
  notes?: string;
};

const deviceBlocklistService = () => {
  const lookup = async (params: DeviceLookupParams): Promise<{ items: DeviceFingerprintRow[] }> => {
    return ChiroUpAPI.get('api', '/device-fingerprints', { queryParams: params });
  };

  const listBlocklist = async (): Promise<{ items: BlocklistRow[] }> => {
    return ChiroUpAPI.get('api', '/device-blocklist', {});
  };

  const block = async (body: BlockDeviceBody): Promise<{ visitorId: string; blocked: boolean }> => {
    return ChiroUpAPI.post('api', '/device-blocklist', { body });
  };

  const unblock = async (visitorId: string): Promise<{ visitorId: string; blocked: boolean }> => {
    return ChiroUpAPI.del('api', `/device-blocklist/${encodeURIComponent(visitorId)}`, {});
  };

  return { lookup, listBlocklist, block, unblock };
};

export default deviceBlocklistService();
